/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line




/*
* Broadcast Theme – Antonita ATC Modal
*/

  (function () {
    console.log('[ANT] ATC Modal (shape + item) carregado');

    const SELECTORS = {
      addForm: 'form[action*="/cart/add"]',
      addBtn:
        'button[type="submit"][name="add"], button[name="add"], [data-add-to-cart], [data-product-submit]',
    };

    const IDS = {
      backdrop: 'ant-atc-modal',
      title: 'ant-atc-title',
      close: 'ant-atc-close',
      btnContinue: 'ant-atc-continue',
      btnGoCart: 'ant-atc-gocart',
      error: 'ant-atc-error',
    };

    // ---------- helpers ----------
    function moneyBRL(cents) {
      const n = Number(cents);
      if (!Number.isFinite(n)) return '';
      try {
        return (n / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
      } catch (e) {
        return `R$ ${(n / 100).toFixed(2)}`.replace('.', ',');
      }
    }

    function getItemImageUrl(item) {
      // cart.js (mais confiável)
      if (typeof item?.image === 'string' && item.image) return item.image;

      // add.js (variações)
      if (item?.featured_image?.url) return item.featured_image.url;
      if (typeof item?.featured_image === 'string') return item.featured_image;
      if (typeof item?.featured_image?.src === 'string') return item.featured_image.src;

      return '';
    }



    function renderAddedItem(item) {
      const wrap = document.getElementById('ant-atc-item');
      if (!wrap) return;

      const img = document.getElementById('ant-atc-item-img');
      const title = document.getElementById('ant-atc-item-title');
      const meta = document.getElementById('ant-atc-item-meta');
      const price = document.getElementById('ant-atc-item-price');

      const t = item?.product_title || item?.title || item?.name || '';
      const variant =
        item?.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
      const qty = item?.quantity ? `Qtd: ${item.quantity}` : '';
      const metaText = [variant, qty].filter(Boolean).join(' • ');

      const cents = item?.final_price ?? item?.price ?? item?.line_price ?? null;
      const imgUrl = getItemImageUrl(item);

      if (title) title.textContent = t;
      if (meta) meta.textContent = metaText;
      if (price) price.textContent = cents != null ? moneyBRL(cents) : '';

      if (img) {
        if (imgUrl) {
          img.src = imgUrl;
          img.style.display = '';
        } else {
          img.removeAttribute('src');
          img.style.display = 'none';
        }
      }

      wrap.style.display = 'flex';
    }




    function clearAddedItemUI() {
      const wrap = document.getElementById('ant-atc-item');
      const img = document.getElementById('ant-atc-item-img');
      const title = document.getElementById('ant-atc-item-title');
      const meta = document.getElementById('ant-atc-item-meta');
      const price = document.getElementById('ant-atc-item-price');

      if (title) title.textContent = '';
      if (meta) meta.textContent = '';
      if (price) price.textContent = '';

      if (img) {
        img.removeAttribute('src');
        img.style.display = 'none';
      }

      if (wrap) wrap.style.display = 'none';
    }



    // ---------- modal ----------
    function ensureModal() {
      if (document.getElementById(IDS.backdrop)) return;

      const backdrop = document.createElement('div');
      backdrop.className = 'ant-atc-backdrop';
      backdrop.id = IDS.backdrop;

      const SHAPE_URL =
        'https://cdn.shopify.com/s/files/1/0693/3892/3055/files/Logo_Icone_Antonita.svg?v=1767536261';

      backdrop.innerHTML = `
        <div class="ant-atc-modal" role="dialog" aria-modal="true" aria-labelledby="${IDS.title}">
          <div class="ant-atc-shape" aria-hidden="true">
            <img src="${SHAPE_URL}" alt="" loading="eager" decoding="async" />
          </div>

          <div class="ant-atc-content">
            <div class="ant-atc-head">
              <div class="ant-atc-check" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none">
                  <path d="M20 6L9 17l-5-5" stroke="rgba(5,149,123,.95)" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
              </div>

              <div class="ant-atc-headcopy">
                <p id="${IDS.title}" class="ant-atc-title">Prontinho! Já está no carrinho</p>
              </div>

              <button class="ant-atc-close" id="${IDS.close}" type="button" aria-label="Fechar">×</button>
            </div>

            <div class="ant-atc-item" id="ant-atc-item" style="display:none;">
              <div class="ant-atc-item__media">
                <img id="ant-atc-item-img" alt="" loading="eager" decoding="async" />
              </div>
              <div class="ant-atc-item__info">
                <p class="ant-atc-item__title" id="ant-atc-item-title"></p>
                <p class="ant-atc-item__meta" id="ant-atc-item-meta"></p>
              </div>
              <div class="ant-atc-item__price" id="ant-atc-item-price"></div>
            </div>

            <div class="ant-atc-actions">
              <button class="ant-atc-secondary" type="button" id="${IDS.btnContinue}">Continuar explorando</button>
              <a class="ant-atc-primary" href="/cart" id="${IDS.btnGoCart}">Ir para o carrinho</a>
            </div>

            <div class="ant-atc-error" id="${IDS.error}" style="display:none;"></div>
          </div>
        </div>
      `;

      document.body.appendChild(backdrop);

      function hide() {
        const el = document.getElementById(IDS.backdrop);
        if (el) el.style.display = 'none';
        document.documentElement.classList.remove('ant-atc-open');

        // limpa o bloco do item (pra não piscar coisa velha no próximo add)
        const itemWrap = document.getElementById('ant-atc-item');
        if (itemWrap) itemWrap.style.display = 'none';
        const img = document.getElementById('ant-atc-item-img');
        if (img) img.removeAttribute('src');
      }

      backdrop.addEventListener('click', (e) => {
        if (e.target === backdrop) hide();
      });

      backdrop.querySelector(`#${IDS.close}`)?.addEventListener('click', hide);
      backdrop.querySelector(`#${IDS.btnContinue}`)?.addEventListener('click', hide);

      document.addEventListener('keydown', (e) => {
        const el = document.getElementById(IDS.backdrop);
        if (e.key === 'Escape' && el && el.style.display === 'flex') hide();
      });
    }

    function showModal({ errorText } = {}) {
      ensureModal();

      const backdrop = document.getElementById(IDS.backdrop);
      const err = document.getElementById(IDS.error);

      if (err) {
        err.style.display = errorText ? 'block' : 'none';
        err.textContent = errorText || '';
      }

      backdrop.style.display = 'flex';
      document.documentElement.classList.add('ant-atc-open');
    }

    // ---------- cart count (Broadcast-safe) ----------
    function setHeaderCartCount(count) {
      const n = Math.max(0, Number(count) || 0);

      // Broadcast pode ter header “normal” + header sticky/clonado
      const els = document.querySelectorAll(
        'cart-count.header__cart__status, cart-count[data-cart-count], [data-cart-count]'
      );

      if (!els.length) return;

      els.forEach((el) => {
        // <cart-count>
        if (el.tagName && el.tagName.toLowerCase() === 'cart-count') {
          el.setAttribute('data-cart-count', String(n));

          const limit = Number(el.getAttribute('data-limit') || 0);
          el.textContent = limit > 0 && n > limit ? `${limit}+` : String(n);

          // garante visibilidade
          el.hidden = false;
          el.style.display = '';

          const holder = el.closest('.header__cart__status__holder');
          if (holder) {
            holder.hidden = false;
            holder.style.display = '';
          }
          return;
        }

        // fallback genérico (caso exista algum badge com data-cart-count)
        try {
          el.setAttribute('data-cart-count', String(n));
          el.textContent = String(n);
          el.hidden = false;
          el.style.display = '';
        } catch (e) {}
      });
    }

    async function syncHeaderCartCount() {
      try {
        const cart = await fetch('/cart.js?ts=' + Date.now(), {
          headers: { Accept: 'application/json' },
          cache: 'no-store',
        }).then((r) => r.json());

        setHeaderCartCount(cart?.item_count || 0);
      } catch (e) {}
    }

    // ---------- add to cart ----------
    async function ajaxAddToCart(form) {
      const fd = new FormData(form);

      // contador atual do header (antes do add) – pode ser header normal ou sticky
      let prevCount = 0;
      try {
        const cc =
          document.querySelector('cart-count.header__cart__status, cart-count[data-cart-count]') ||
          document.querySelector('cart-count');
        prevCount = Number(cc?.getAttribute('data-cart-count') || cc?.textContent || 0) || 0;
      } catch (e) {}

      let res;
      try {
        res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: fd,
        });
      } catch (err) {
        showModal({ errorText: 'Falha de conexão. Tente novamente.' });
        return;
      }

      if (!res.ok) {
        let msg = 'Não foi possível adicionar ao carrinho.';
        try {
          const j = await res.json();
          if (j?.description || j?.message) msg = j.description || j.message;
        } catch (e) {}
        showModal({ errorText: msg });
        return;
      }

      // sucesso: abre modal + mostra o item
      let added = null;
      try {
        added = await res.json();
      } catch (e) {}

      showModal();
      clearAddedItemUI();

      // Atualiza na hora (otimista)
      setHeaderCartCount(prevCount + 1);

      // reforço rápido (cobre header sticky criado depois)
      setTimeout(() => setHeaderCartCount(prevCount + 1), 60);

      // sincroniza com o backend depois (corrige qualquer caso raro)
      setTimeout(() => syncHeaderCartCount(), 400);

      // render do item: acha o item correto (não usa "last")
      try {
        const cart = await fetch('/cart.js?ts=' + Date.now(), {
          headers: { Accept: 'application/json' },
          cache: 'no-store',
        }).then(r => r.json());

        let picked = null;

        // melhor caso: key do line item
        if (added?.key) {
          picked = cart?.items?.find(i => i.key === added.key) || null;
        }

        // fallback: id da variante (add.js retorna em "id")
        if (!picked && added?.id) {
          picked = cart?.items?.find(i => Number(i.id) === Number(added.id)) || null;
        }

        renderAddedItem(picked || added);
      } catch (e) {
        if (added) renderAddedItem(added);
      }

    }

    function lockButton(btn, locked) {
      if (!btn) return;
      btn.disabled = !!locked;
      btn.classList.toggle('is-loading', !!locked);
      btn.setAttribute('aria-busy', locked ? 'true' : 'false');
    }

    // SUBMIT em capture phase
    document.addEventListener(
      'submit',
      function (e) {
        const form = e.target;
        if (!form || !form.matches(SELECTORS.addForm)) return;

        e.preventDefault();
        e.stopPropagation();

        const btn = form.querySelector(SELECTORS.addBtn);
        lockButton(btn, true);

        ajaxAddToCart(form).finally(() => lockButton(btn, false));
      },
      true
    );

    // HARD MODE: clique no add (impede o tema de navegar)
    document.addEventListener(
      'click',
      function (e) {
        const btn = e.target.closest(SELECTORS.addBtn);
        if (!btn) return;

        const form = btn.closest(SELECTORS.addForm);
        if (!form) return;

        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        try {
          form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
        } catch (err) {
          console.warn('[ANT] Falha ao disparar submit:', err);
        }
      },
      true
    );
  })();

  







  /**
 * Antonita - Recomendador de Tamanho + UI (MVP revisado)
 * Tipo do Shopify: Vestido | Camisa | Short | Conjunto | etc.
 * Metacampo: custom.tabela_de_medidas (JSON)
 *
 * NOVO UX:
 * - Tabela SEMPRE aparece ao abrir o accordion (neutra, sem highlight).
 * - Resultado é somente texto (não repete tabela).
 *
 * Regras:
 * - Retorna o MENOR tamanho que comporta todas as medidas relevantes informadas.
 * - Se nenhuma opção comportar, retorna o MAIOR tamanho disponível no JSON.
 */

(function () {
  const TYPE_RULES = {
    vestido: ["busto", "comprimento"],
    macacao: ["busto", "cintura", "comprimento"],
    camisa: ["busto", "comprimento"],
    blusa: ["busto", "comprimento"],
    short: ["cintura", "comprimento"],
    calca: ["cintura", "comprimento"],
    conjunto: ["busto", "cintura", "comprimento"] // especial
  };

  function normalizeType(type) {
    return String(type || "")
      .trim()
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");
  }

  function toNum(v) {
    const n =
      typeof v === "number"
        ? v
        : parseFloat(String(v || "").replace(",", "."));
    return Number.isFinite(n) ? n : 0;
  }

  // Aceita:
  // - objeto { "2": {busto,...}, "4": {...} }
  // - { value: objeto }
  // - string JSON
  // - array [{size:"4", busto:..}, ...]
  function normalizeTable(raw) {
    if (!raw) return {};

    let t = raw;

    if (typeof t === "string") {
      try {
        t = JSON.parse(t);
      } catch (e) {
        return {};
      }
    }

    if (t && typeof t === "object" && t.value && typeof t.value === "object") {
      t = t.value;
    }

    // Se veio como array de objetos
    if (Array.isArray(t)) {
      const out = {};
      t.forEach((row) => {
        const s = row?.size ?? row?.tamanho ?? row?.Size ?? row?.Tamanho;
        if (!s) return;
        const key = String(s).trim();
        out[key] = {
          busto: row?.busto ?? row?.Busto ?? 0,
          cintura: row?.cintura ?? row?.Cintura ?? 0,
          comprimento: row?.comprimento ?? row?.Comprimento ?? 0
        };
      });
      return out;
    }

    // Se já parece mapa por tamanho
    if (t && typeof t === "object") {
      const keys = Object.keys(t);
      const hasRealSizes = keys.some((k) => {
        const n = parseFloat(k);
        return Number.isFinite(n) && n >= 1 && n <= 20;
      });
      if (!hasRealSizes) return {};
      return t;
    }

    return {};
  }

  function getSortedSizes(tableObj) {
    return Object.keys(tableObj)
      .map((k) => toNum(k))
      .filter((n) => n > 0)
      .sort((a, b) => a - b);
  }


  const ANT_SIZE_ORDER = ["PP","P","M","G","GG","1","2","3","4","6","8","10","12","14","16"];

  function sizeRank(sizeKey){
    const k = String(sizeKey || "").trim().toUpperCase();
    const idx = ANT_SIZE_ORDER.indexOf(k);
    if (idx !== -1) return idx;

    const n = parseFloat(k);
    if (Number.isFinite(n)) return 100 + n;

    return 9999;
  }

  function getOrderedSizeKeysForRecommender(tableObj){
    return Object.keys(tableObj || {})
      .map(k => String(k).trim())
      .filter(Boolean)
      .sort((a,b) => sizeRank(a) - sizeRank(b));
  }



  function measurePasses(refValue, inputValue) {
    const ref = toNum(refValue);
    if (ref <= 0) return false;
    return inputValue <= ref;
  }

  /**
   * recommendSize()
   * @returns {Object} { size, status, maxSize, failedMeasures, usedMeasures, debug, reason }
   */
  function recommendSize({ productType, table, input }) {
    const normType = normalizeType(productType);
    const usedMeasures = TYPE_RULES[normType] || ["busto", "cintura", "comprimento"];
    const isConjunto = normType === "conjunto";

    const t = normalizeTable(table);
    if (!t || !Object.keys(t).length) {
      return {
        size: null,
        status: "invalid_table",
        maxSize: null,
        failedMeasures: [],
        usedMeasures,
        debug: null,
        reason: "Tabela de medidas inválida ou vazia."
      };
    }

    // ✅ agora trabalha com CHAVES (P/M/G/1/2/3/4/6...)
    const sizeKeys = getOrderedSizeKeysForRecommender(t);
    if (!sizeKeys.length) {
      return {
        size: null,
        status: "no_sizes",
        maxSize: null,
        failedMeasures: [],
        usedMeasures,
        debug: null,
        reason: "Tabela de medidas sem tamanhos."
      };
    }

    const inputClean = {
      busto: toNum(input?.busto),
      cintura: toNum(input?.cintura),
      comprimento: toNum(input?.comprimento)
    };

    const debug = sizeKeys.map((key) => {
      const ref = t[key] || {};

      const checks = usedMeasures.map((m) => {
        const iv = inputClean[m];
        const active = iv > 0;
        const pass = !active ? true : measurePasses(ref[m], iv);
        return { measure: m, active, input: iv, ref: toNum(ref[m]), pass };
      });

      let ok;
      if (isConjunto) {
        const mainChecks = checks.filter((c) => c.measure !== "cintura");
        const cinturaCheck = checks.find((c) => c.measure === "cintura");

        ok = mainChecks.every((c) => c.pass);

        // regra especial: se busto/comprimento passam, mas cintura estoura, força subir tamanho
        if (ok && cinturaCheck && cinturaCheck.active && !cinturaCheck.pass) ok = false;
      } else {
        ok = checks.every((c) => c.pass);
      }

      return { size: key, ok, checks };
    });

    const firstOk = debug.find((row) => row.ok);
    if (firstOk) {
      return {
        size: firstOk.size, // ✅ agora pode ser "P"
        status: "ok",
        maxSize: sizeKeys[sizeKeys.length - 1], // ✅ pode ser "3" ou "16"
        failedMeasures: [],
        usedMeasures,
        debug,
        reason: "Primeiro tamanho que comporta as medidas informadas."
      };
    }

    const maxSize = sizeKeys[sizeKeys.length - 1];
    const maxRow = debug.find((row) => row.size === maxSize);

    const failedMeasures = (maxRow?.checks || [])
      .filter((c) => c.active && !c.pass)
      .map((c) => c.measure);

    return {
      size: maxSize,
      status: "fallback_max",
      maxSize,
      failedMeasures,
      usedMeasures,
      debug,
      reason: "Nenhum tamanho comportou tudo. Retornando o maior disponível."
    };
  }


  // Expondo para testes
  window.ANT_SizeRecommender = { recommendSize };
  console.log("[ANT] SizeRecommender carregado.");
})();





(function () {
  function normalizeType(type) {
    return String(type || "")
      .trim()
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");
  }

  function toNum(v) {
    const n = typeof v === "number" ? v : parseFloat(String(v || "").replace(",", "."));
    return Number.isFinite(n) ? n : 0;
  }

  const UI_BY_TYPE = {
    vestido: { label: "Comprimento do vestido (cm)", help: "Meça do ombro até onde o vestido costuma bater." },
    macacao: { label: "Comprimento do macacão (cm)", help: "Meça do ombro até onde o macacão costuma bater." },
    conjunto: { label: "Comprimento da blusa (cm)", help: "Meça apenas a blusa. Não inclua o short ou a calça." },
    camisa: { label: "Comprimento da camisa (cm)", help: "Meça do ombro até a barra da camisa." },
    blusa: { label: "Comprimento da blusa (cm)", help: "Meça do ombro até a barra da blusa." },
    short: { label: "Comprimento do short (cm)", help: "Meça da cintura até a barra do short." },
    calca: { label: "Comprimento da calça (cm)", help: "Meça da cintura até a barra da perna." }
  };


  const IMAGE_BY_TYPE = {
    vestido:  "medir-vestido.png",
    macacao:  "medir-macacao.png",
    camisa:   "medir-camisa.png",
    blusa:    "medir-blusa.png",
    short:    "medir-short.png",
    calca:    "medir-calca.png",
    conjunto: "medir-conjunto.png" // mede só a blusa
  };



  const FIELD_RULES = {
    vestido: ["busto", "comprimento"],
    macacao: ["busto", "cintura", "comprimento"],
    conjunto: ["busto", "cintura", "comprimento"],
    camisa: ["busto", "comprimento"],
    blusa: ["busto", "comprimento"],
    short: ["cintura", "comprimento"],
    calca: ["cintura", "comprimento"]
  };

  const TABLE_COLUMNS = {
    vestido: ["busto", "comprimento"],
    camisa: ["busto", "comprimento"],
    blusa: ["busto", "comprimento"],
    macacao: ["busto", "cintura", "comprimento"],
    conjunto: ["busto", "cintura", "comprimento"],
    short: ["cintura", "comprimento"],
    calca: ["cintura", "comprimento"]
  };

  function normalizeTable(raw) {
    if (!raw) return {};

    let t = raw;
    if (typeof t === "string") {
      try { t = JSON.parse(t); } catch (e) { return {}; }
    }
    if (t && typeof t === "object" && t.value && typeof t.value === "object") t = t.value;

    if (Array.isArray(t)) {
      const out = {};
      t.forEach((row) => {
        const s = row?.size ?? row?.tamanho ?? row?.Size ?? row?.Tamanho;
        if (!s) return;
        const key = String(s).trim();
        out[key] = {
          busto: row?.busto ?? row?.Busto ?? 0,
          cintura: row?.cintura ?? row?.Cintura ?? 0,
          comprimento: row?.comprimento ?? row?.Comprimento ?? 0
        };
      });
      return out;
    }

    if (t && typeof t === "object") {
      const keys = Object.keys(t);
      const hasRealSizes = keys.some((k) => {
        const n = parseFloat(k);
        return Number.isFinite(n) && n >= 1 && n <= 20;
      });
      if (!hasRealSizes) return {};
      return t;
    }

    return {};
  }




  // Funcao feita para organizar as tabelas contemplando o tamanhos P M G
  function isNumericSizeKey(k){
    return /^\d+(\.\d+)?$/.test(String(k).trim());
  }

  function getOrderedSizeKeys(tableObj){
    const keys = Object.keys(tableObj || {}).map(k => String(k).trim()).filter(Boolean);

    const hasBaby = keys.some(k => ["PP","P","M","G","GG","1","2","3"].includes(k.toUpperCase()));

    if (hasBaby){
      const order = ["PP","P","M","G","GG","1","2","3","4","6","8","10","12","14","16"];
      const rank = new Map(order.map((v,i)=>[v,i]));

      return keys.slice().sort((a,b)=>{
        const A = a.toUpperCase();
        const B = b.toUpperCase();
        const ra = rank.has(A) ? rank.get(A) : 999;
        const rb = rank.has(B) ? rank.get(B) : 999;

        if (ra !== rb) return ra - rb;

        const an = isNumericSizeKey(a) ? parseFloat(a) : null;
        const bn = isNumericSizeKey(b) ? parseFloat(b) : null;
        if (an !== null && bn !== null) return an - bn;
        if (an !== null) return -1;
        if (bn !== null) return 1;
        return a.localeCompare(b, "pt-BR");
      });
    }

    return keys.slice().sort((a,b)=>{
      const an = isNumericSizeKey(a) ? parseFloat(a) : null;
      const bn = isNumericSizeKey(b) ? parseFloat(b) : null;

      if (an !== null && bn !== null) return an - bn;
      if (an !== null) return -1;
      if (bn !== null) return 1;
      return a.localeCompare(b, "pt-BR");
    });
  }







  // Renderiza tabela NEUTRA (sem destacar recomendado)
  function renderTableNeutral(rawTable, productType) {
    const typeNorm = normalizeType(productType);
    const visibleCols = TABLE_COLUMNS[typeNorm] || ["busto", "cintura", "comprimento"];

    const tableObj = normalizeTable(rawTable);

    const sizes = getOrderedSizeKeys(tableObj);

    const row = (v) => (toNum(v) > 0 ? toNum(v) : "–");

    if (!sizes.length) {
      return `<div style="margin-top:10px;padding:10px;border:1px solid rgba(0,0,0,.10);border-radius:12px;">
        Não encontramos a tabela de medidas desta peça. Se quiser, chama a gente que te ajudamos rapidinho.
      </div>`;
    }

    let html = '';
    html += '<div class="ant-sizehelp__tablewrap">';
    html += '<table class="ant-sizehelp__table" style="width:100%;border-collapse:collapse;">';
    html += '<thead><tr>';
    html += '<th style="padding:10px 12px;border-bottom:1px solid rgba(0,0,0,.08);text-align:left;">Tamanho</th>';

    visibleCols.forEach((col) => {
      const label =
        col === "busto" ? "Busto (cm)" :
        col === "cintura" ? "Cintura (cm)" :
        "Comprimento (cm)";
      html += `<th style="padding:10px 12px;border-bottom:1px solid rgba(0,0,0,.08);text-align:left;">${label}</th>`;
    });

    html += '</tr></thead><tbody>';

    sizes.forEach((s) => {
      const r = tableObj[s] || {};
      html += `<tr>`;
      html += `<td style="padding:10px 12px;border-bottom:1px solid rgba(0,0,0,.08);font-weight:600;">${s}</td>`;
      visibleCols.forEach((col) => {
        html += `<td style="padding:10px 12px;border-bottom:1px solid rgba(0,0,0,.08);">${row(r[col])}</td>`;
      });
      html += `</tr>`;
    });

    html += '</tbody></table></div>';
    return html;
  }

  function initOne(root) {
    if (!root || root.dataset.antSizehelpInit === "1") return;
    root.dataset.antSizehelpInit = "1";

    const jsonEl = root.querySelector('[data-ant-sizehelp-json]');
    if (!jsonEl) return;

    let data;
    try {
      data = JSON.parse(jsonEl.textContent);
    } catch (e) {
      console.warn("[ANT] JSON inválido em data-ant-sizehelp-json");
      return;
    }

    const typeNorm = normalizeType(data.type);

    // 🖼️ ajusta imagem de medição conforme tipo do produto
    const imgMap = IMAGE_BY_TYPE || {};
    const visualImg = root.querySelector(".ant-sizehelp__visual img");

    if (visualImg) {
      const imgName = imgMap[typeNorm];

      if (imgName) {
        // ajuste o path se suas imagens estiverem em outra pasta
        visualImg.src = `https://cdn.shopify.com/s/files/1/0693/3892/3055/files/${imgName}`;
      }
    }


    const visibleFields = FIELD_RULES[typeNorm] || ["busto", "cintura", "comprimento"];

    // mostra/esconde campos conforme tipo
    ["busto", "cintura", "comprimento"].forEach((field) => {
      const row = root.querySelector(`[data-ant-field="${field}"]`);
      if (!row) return;

      if (visibleFields.includes(field)) {
        row.hidden = false;
      } else {
        row.hidden = true;
        const input = row.querySelector("input");
        if (input) input.value = "";
      }
    });

    // ajusta label/help do comprimento
    const ui = UI_BY_TYPE[typeNorm] || { label: "Comprimento (cm)", help: "Meça do ombro até a barra da peça." };
    const labelEl = root.querySelector("[data-ant-label-comprimento]");
    const helpEl = root.querySelector("[data-ant-help-comprimento]");
    if (labelEl) labelEl.textContent = ui.label;
    if (helpEl) helpEl.textContent = ui.help;

    // ✅ NOVO: renderiza tabela sempre (neutra) no container correto
    const alwaysTableMount = root.querySelector("[data-ant-table-always]");
    if (alwaysTableMount) {
      const tableToUse = (data.table && data.table.value) ? data.table.value : data.table;
      alwaysTableMount.innerHTML = renderTableNeutral(tableToUse, data.type);
    }

    const btn = root.querySelector("[data-ant-run]");
    const resultBox = root.querySelector("[data-ant-result]");
    const resultTitle = root.querySelector("[data-ant-result-title]");
    const resultCopy = root.querySelector("[data-ant-result-copy]");

    if (!btn) return;

    function getInputEl(k) {
      return root.querySelector(`[data-ant-input="${k}"]`);
    }

    function getInput(k) {
      const el = getInputEl(k);
      return el ? toNum(el.value) : 0;
    }

    function clearFieldError(k) {
      const el = getInputEl(k);
      if (!el) return;
      el.classList.remove("ant-input--error");
      el.removeAttribute("aria-invalid");
    }

    function setFieldError(k) {
      const el = getInputEl(k);
      if (!el) return;
      el.classList.add("ant-input--error");
      el.setAttribute("aria-invalid", "true");
    }

    function isValidNumberString(str) {
      return /^\d+([.,]\d+)?$/.test(str);
    }

    function validateRequiredFields(requiredFields) {
      requiredFields.forEach(clearFieldError);

      for (const field of requiredFields) {
        const el = getInputEl(field);
        if (!el) continue;

        const raw = String(el.value || "").trim();

        if (!raw) {
          return { ok: false, field, message: "Preencha todos os campos para ver o tamanho recomendado." };
        }
        if (!isValidNumberString(raw)) {
          return { ok: false, field, message: "Use apenas números (ex: 58)." };
        }
        const n = toNum(raw);
        if (!(n > 0)) {
          return { ok: false, field, message: "Digite uma medida válida maior que zero." };
        }
      }

      return { ok: true };
    }

    btn.addEventListener("click", function () {
      if (!window.ANT_SizeRecommender || !window.ANT_SizeRecommender.recommendSize) {
        console.warn("[ANT] SizeRecommender não carregou. Confirme se está no custom.js");
        return;
      }

      // ✅ RESET total do estado visual (pra não herdar cor do teste anterior)
      if (resultBox) {
        resultBox.classList.remove("is-fallback", "is-error");
      }

      const v = validateRequiredFields(visibleFields);

      if (!v.ok) {
        if (resultBox) {
          resultBox.hidden = false;
          resultBox.classList.add("is-error"); // ✅ erro = laranja
        }

        if (resultTitle) resultTitle.textContent = "Faltou uma informação 🙂";
        if (resultCopy) resultCopy.innerHTML = `<p style="margin:0;">${v.message}</p>`;

        setFieldError(v.field);
        const el = getInputEl(v.field);
        if (el) el.focus();
        return;
      }

      const input = {
        busto: getInput("busto"),
        cintura: getInput("cintura"),
        comprimento: getInput("comprimento")
      };

      const res = window.ANT_SizeRecommender.recommendSize({
        productType: data.type,
        table: (data.table && data.table.value) ? data.table.value : data.table,
        input
      });

      if (!res || !res.size) {
        if (resultBox) {
          resultBox.hidden = false;
          resultBox.classList.add("is-error"); // ✅ erro = laranja
        }

        if (resultTitle) resultTitle.textContent = "Não conseguimos calcular com essas informações.";
        if (resultCopy) resultCopy.innerHTML = '<p style="margin:0;">Tente novamente com medidas válidas.</p>';
        return;
      }

      if (resultBox) resultBox.hidden = false;

      // ✅ aplica fallback só quando for fallback
      if (resultBox) {
        resultBox.classList.toggle("is-fallback", res.status === "fallback_max");
        // (is-error já foi removida no reset lá em cima)
      }

      if (resultCopy) {
        if (res.status === "fallback_max") {

          if (resultTitle) {
            resultTitle.textContent = "As medidas informadas são maiores que a tabela desta peça";
          }

          const where = (res.failedMeasures && res.failedMeasures.length)
            ? `em: ${res.failedMeasures.join(", ")}`
            : "nas medidas informadas";

          const why = `Pelas medidas que você informou, nenhum tamanho desta peça comporta tudo com conforto.`;
          const note = `O maior tamanho disponível é o ${res.maxSize}, mas ele ainda pode ficar justo ${where}.`;

          resultCopy.innerHTML = `
            <p style="margin:2px 0 1px 0;">${why}</p>
            <p style="margin:0 0 8px 0;">${note}</p>
            <p style="margin:0; font-size:0.92em; opacity:0.8; font-style:italic;">
              Você conhece sua filha melhor do que ninguém. Use a tabela <strong>acima</strong> para confirmar o que faz mais sentido para ela.
            </p>
          `;

        } else {

          if (resultTitle) resultTitle.textContent = `Recomendamos o tamanho ${res.size}`;

          resultCopy.innerHTML = `
            <p style="margin:0 0 8px 0;">
              Esse é o tamanho que melhor se adapta às medidas que você informou, garantindo conforto para brincar e se movimentar.
            </p>
            <p style="margin:0; font-size:0.92em; opacity:0.75;font-style:italic;">
              Você conhece sua filha melhor do que ninguém. Use a tabela <strong>acima</strong> para confirmar o que faz mais sentido para ela.
            </p>
          `;
        }
      }
    });


  }

  // Broadcast/Shopify: muitas vezes o conteúdo só existe após abrir o details,
  // então iniciamos no DOM e também no toggle do details.
  function initAll() {
    document.querySelectorAll("[data-ant-sizehelp]").forEach(initOne);
  }

  function bindDetailsToggle() {
    document.querySelectorAll("details.ant-sizehelp-accordion").forEach((details) => {
      if (details.dataset.antBindToggle === "1") return;
      details.dataset.antBindToggle = "1";

      details.addEventListener("toggle", () => {
        if (details.open) {
          // quando abre, garante init (e tabela)
          details.querySelectorAll("[data-ant-sizehelp]").forEach(initOne);
        }
      });
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    initAll();
    bindDetailsToggle();
  });

  document.addEventListener("shopify:section:load", function () {
    initAll();
    bindDetailsToggle();
  });
})();






// //////////////////////////////////////////
// //////////////////////////////////////////
// Script para abrir modal da tabela INMETRO
// //////////////////////////////////////////
document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-ant-open-bodytable]');
  if (!btn) return;

  e.preventDefault();

  const trigger = document.querySelector('.selector-wrapper--size popup-component a');
  if (trigger) trigger.click();
});











/*
* Script Brinde Steps Carrinho
*/
document.addEventListener('DOMContentLoaded', function () {
  (function () {
    const mounts = Array.from(document.querySelectorAll('.ant-giftbar-mount'));
    if (!mounts.length) return;

    let steps = [];
    try { steps = JSON.parse(mounts[0].dataset.steps || "[]"); } catch(e) { steps = []; }
    if (!steps.length) { mounts.forEach(m => m.remove()); return; }

    steps.sort((a,b) => a.threshold_cents - b.threshold_cents);
    steps = steps.slice(0, 2);

    function moneyBRL(cents){
      return (cents/100).toLocaleString('pt-BR',{style:'currency',currency:'BRL'});
    }

    async function getCart(){
      return fetch('/cart.js?ts=' + Date.now(), { cache:'no-store' }).then(r => r.json());
    }

    async function setAttributes(attrs){
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: {'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({ attributes: attrs })
      }).then(r => r.json());
    }

    function render(subtotalCents){
      const maxTarget = steps[steps.length - 1].threshold_cents;
      const pct = Math.max(0, Math.min(100, (subtotalCents / maxTarget) * 100));

      const s1 = steps[0];
      const s2 = steps[1];

      const hit1 = !!s1 && subtotalCents >= s1.threshold_cents;
      const hit2 = !!s2 && subtotalCents >= s2.threshold_cents;

      let message = "";
      if (steps.length === 1){
        if (!hit1){
          message = `Adicione ${moneyBRL(s1.threshold_cents - subtotalCents)} para ganhar <strong>${(s1.label || s1.title)}</strong>.`;
        } else {
          message = `Você ganhou ${s1.article} <strong>${(s1.label || s1.title)}</strong> 🎁`;
        }
      } else {
        if (!hit1){
          message = `Adicione ${moneyBRL(s1.threshold_cents - subtotalCents)} para ganhar ${s1.article} <strong>${(s1.label || s1.title)}</strong>.`;
        } else if (hit1 && !hit2){
          message = `Você ganhou ${s1.article} <strong>${(s1.label || s1.title)}</strong>. <br> Adicione mais ${moneyBRL(s2.threshold_cents - subtotalCents)} para ganhar ${s1.article} <strong>${(s2.label || s2.title)}</strong>.`;
        } else {
          message = `Você garantiu seus presentes: ${s1.article} <strong>${(s1.label || s1.title)}</strong> e ${s1.article} <strong>${(s2.label || s2.title)}</strong>.`;
        }
      }

      function giftCard(step, isHit){
        const img = step.image
          ? `<div class="ant-giftbar__giftImg"><img src="${step.image}" alt=""></div>`
          : `<div class="ant-giftbar__giftImg"></div>`;

        const pill = isHit
          ? `<span class="ant-giftbar__pill ant-giftbar__pill--hit">Você ganhou!</span>`
          : `<span class="ant-giftbar__pill">Ao atingir ${moneyBRL(step.threshold_cents)}</span>`;

        return `
          <div class="ant-giftbar__gift ${isHit ? "is-hit" : ""}">
            ${img}
            <p class="ant-giftbar__giftName">${step.label || step.title}</p>
            ${pill}
          </div>
        `;
      }

      const giftsHtml = steps
        .map(s => giftCard(s, subtotalCents >= s.threshold_cents))
        .join("");

      mounts.forEach(m => {
        m.innerHTML = `
          <div class="ant-giftbar">
            <p class="ant-giftbar__kicker">🎁 Garanta presentes em sua compra!</p>
            <p class="ant-giftbar__message">${message}</p>
            <div class="ant-giftbar__track" aria-hidden="true">
              <div class="ant-giftbar__fill" style="width:${pct}%;"></div>
            </div>
            <div class="ant-giftbar__gifts">
              ${giftsHtml}
            </div>
          </div>
        `;
      });
    }

    async function sync(){
      const cart = await getCart();
      const subtotal = Number(cart.items_subtotal_price || 0);

      render(subtotal);

      const hit1 = !!steps[0] && subtotal >= steps[0].threshold_cents;
      const hit2 = !!steps[1] && subtotal >= steps[1].threshold_cents;

      const attrs = {
        ant_gift_step1: hit1 ? (steps[0].handle || "") : "",
        ant_gift_step1_label: hit1 ? (steps[0].label || steps[0].title || "") : "",
        ant_gift_step2: hit2 ? (steps[1].handle || "") : "",
        ant_gift_step2_label: hit2 ? (steps[1].label || steps[1].title || "") : ""
      };

      const cur = cart.attributes || {};
      const changed =
        (cur.ant_gift_step1 || "") !== (attrs.ant_gift_step1 || "") ||
        (cur.ant_gift_step1_label || "") !== (attrs.ant_gift_step1_label || "") ||
        (cur.ant_gift_step2 || "") !== (attrs.ant_gift_step2 || "") ||
        (cur.ant_gift_step2_label || "") !== (attrs.ant_gift_step2_label || "");

      if (changed) await setAttributes(attrs);
    }

    sync().catch(()=>{});

    let t;
    const debounced = () => { clearTimeout(t); t = setTimeout(() => sync().catch(()=>{}), 250); };
    document.addEventListener('click', (e) => {
      if (e.target && e.target.closest && e.target.closest('button, a, input')) debounced();
    });
    document.addEventListener('change', debounced);


  // Reage a updates AJAX do carrinho (remoção/atualização sem refresh)
  const cartRoot = document.querySelector('[data-cart-page]') || document.querySelector('.cart');
  if (cartRoot && window.MutationObserver) {
    const mo = new MutationObserver(() => debounced());
    mo.observe(cartRoot, { childList: true, subtree: true });
}



  })();
});














  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
